import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { ProductReveal } from '../components/ProductReveal';
import { ModulesGrid } from '../components/ModulesGrid';
import { BonusStack } from '../components/BonusStack';
import { ValueComparison } from '../components/ValueComparison';
import { Testimonials } from '../components/Testimonials';
import { FinalCTA } from '../components/FinalCTA';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-[#0B1C2C]" data-id="element-254">
      <Hero data-id="element-255" />
      <ProblemSection data-id="element-256" />
      <ProductReveal data-id="element-257" />
      <ModulesGrid data-id="element-258" />
      <BonusStack data-id="element-259" />
      <ValueComparison data-id="element-260" />
      <Testimonials data-id="element-261" />
      <FinalCTA data-id="element-262" />
      <SocialProofPopup data-id="element-263" />
    </div>;
}